module.exports = __webpack_public_path__ + "media/museum_demo.57921d0c.mp4";